import { jsxs as y, jsx as m } from "react/jsx-runtime";
import { a as V } from "../../core-DVmjA3_O.js";
import { _ as f } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import S from "../InlineLayout/index.js";
import '../../index14.css';const b = "_button-layout_3xra5_1", z = "_before_3xra5_20", h = "_after_3xra5_21", p = "_with-full-width_3xra5_25", g = "_color-variant-text_3xra5_29", v = "_color-variant-text-on-dark_3xra5_33", T = "_color-variant-primary_3xra5_37", O = "_color-variant-secondary_3xra5_41", w = "_color-variant-success_3xra5_45", F = "_color-variant-danger_3xra5_49", k = "_style-variant-outline_3xra5_53", L = "_style-variant-filled_3xra5_58", D = "_style-variant-transparent_3xra5_62", N = "_style-variant-translucent_3xra5_68", P = "_style-variant-action_3xra5_74", C = "_text-size-extra-small_3xra5_80", A = "_text-size-small_3xra5_84", I = "_text-size-medium_3xra5_88", W = "_text-size-large_3xra5_92", E = "_disabled_3xra5_96", M = "_visual-feedback_3xra5_100", j = "_readOnly_3xra5_122", a = {
  buttonLayout: b,
  before: z,
  after: h,
  withFullWidth: p,
  colorVariantText: g,
  colorVariantTextOnDark: v,
  colorVariantPrimary: T,
  colorVariantSecondary: O,
  colorVariantSuccess: w,
  colorVariantDanger: F,
  styleVariantOutline: k,
  styleVariantFilled: L,
  styleVariantTransparent: D,
  styleVariantTranslucent: N,
  styleVariantAction: P,
  textSizeExtraSmall: C,
  textSizeSmall: A,
  textSizeMedium: I,
  textSizeLarge: W,
  disabled: E,
  visualFeedback: M,
  readOnly: j
}, B = {
  text: a.colorVariantText,
  primary: a.colorVariantPrimary,
  secondary: a.colorVariantSecondary,
  success: a.colorVariantSuccess,
  danger: a.colorVariantDanger,
  "text-on-dark": a.colorVariantTextOnDark
}, q = {
  outline: a.styleVariantOutline,
  filled: a.styleVariantFilled,
  transparent: a.styleVariantTransparent,
  translucent: a.styleVariantTranslucent,
  action: a.styleVariantAction
}, G = {
  xs: a.textSizeExtraSmall,
  sm: a.textSizeSmall,
  md: a.textSizeMedium,
  lg: a.textSizeLarge
};
function U(r) {
  const {
    colorVariant: e = "secondary",
    styleVariant: n = "translucent",
    spacingOffset: i,
    className: l,
    disabled: o,
    children: s,
    withoutPadding: c = !1,
    withFullWidth: _ = !1,
    textSize: t,
    readOnly: d,
    withoutAdditionalInlinePadding: x = !1,
    ...u
  } = r;
  return /* @__PURE__ */ y(
    S,
    {
      withPadding: !c,
      className: f(
        a.buttonLayout,
        B[e],
        q[n],
        o && a.disabled,
        _ && a.withFullWidth,
        V(t) && G[t],
        d && a.readOnly,
        l
      ),
      spacingOffset: i,
      withAdditionalInlinePadding: !x,
      withInlineDisplay: !0,
      beforeContainerClassName: a.before,
      afterContainerClassName: a.after,
      ...u,
      children: [
        s,
        /* @__PURE__ */ m("span", { className: a.visualFeedback })
      ]
    }
  );
}
export {
  U as default
};
